import { View } from "react-native";

import CodeInput from "./CodeInput";
import TextInputHelperText from "../../../../../components/TextInputHelperText";

export const OTP_TOKEN_LENGTH = 6;

type Props = {
  code: string;
  error: string;
  setCode: (code: string) => void;
};

export default function VerificationInput({ code, error, setCode }: Props) {
  return (
    <View>
      <CodeInput
        code={code}
        setCode={setCode}
        maximumLength={OTP_TOKEN_LENGTH}
        hasError={!!error}
      />

      <TextInputHelperText info="" error={error} />
    </View>
  );
}
